import { api } from './_client';
import type { TenderEmailListResponse } from '../../types/api';

export const tendersApi = {
  async getTenderEmails(status?: string, limit?: number): Promise<TenderEmailListResponse> {
    const params: Record<string, string | number> = {};
    if (status) params.status = status;
    if (limit) params.limit = limit;
    const response = await api.get<TenderEmailListResponse>('/api/tenders/emails', { params });
    return response.data;
  },

  async reprocessTenderEmail(emailId: string): Promise<{ status: string; message: string }> {
    const response = await api.post<{ status: string; message: string }>(
      `/api/tenders/reprocess/${encodeURIComponent(emailId)}`
    );
    return response.data;
  },
};
